import * as R from 'ramda';
import { Endpoints } from '../../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../../core/api/module';
import { ActionType } from '../../../../core/redux/actionType';
import { actionsByItemId } from '../../module';
import { DevPlanAction } from '../../models';


const KEY_ACTION = ActionType.GetDevPlanActionsRequest;
const ACTIONS    = [
  ActionType.GetDevPlanActionsRequest,
  ActionType.GetDevPlanActionsResponse,
  ActionType.GetDevPlanActionsError,
];


type Payload = DevPlanAction[];

type Meta = {
  projectId: number;
  participantId: number;
};


/**
 * Dispatch this action to get the list of dev plan actions made by the user
 */
export const getDevPlanActionsAction = (projectId: number, participantId: number) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.GetDevPlanActions,
  headers:  { 'content-type': 'application/json' },
  body:     JSON.stringify({ projectId, participantId }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['devPlan', 'actionsByItemId'], actionsByItemId(payload || []), successState);
};


export const getDevPlanActionsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
